import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'

import { jwtDecode } from 'jwt-decode';
import API from "@/connect/config";
import axios from "axios";

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
  },
  state: {
    saveChang: [],
    mapall: []
  },
  mutations: {
    addMapAll(state, payload) {
      console.log(payload)
      state.mapall = [];
      state.mapall.push(payload);
    },
    addChang(state, payload) {
      state.saveChang = [];
      state.saveChang.push(payload);
    },
  },
  actions: {

    async getAuthorization({ commit, dispatch }) {
      const urlpermit = `${API}permit`;
      const refreshToken = localStorage.getItem('refresh_token');
      try {
        const restoken = await axios.post(
          urlpermit,
          {}, // ส่ง empty body
          {
            headers: {
              Authorization: refreshToken,
            },
          }
        );
        //console.log(restoken.data.message);
        const _acc = restoken.data.message.access_token;
        //  console.log(_acc);
        return _acc;
      } catch (error) {
        console.error(
          "❌ Error while getting token:",
          error.response?.data || error.message
        );
        globalRouter.push({ name: 'login' });
      }
      // console.log(localStorage.getItem('refresh_token'));
      // console.log(`${API}permit`);
      // const url = `${API}permit`;
      // const headers = {
      //   Authorization: localStorage.getItem('refresh_token'),
      // };
      // const res = await axios.post(url, headers);
      // console.log(res.data.message)
      // if (res.data.message.access_token) {
      //   console.log('res.data.message.access_token')
      //   console.log(res.data.message.access_token)
      //   return res.data.message.access_token;
      // } else {
      //   console.log('no access');
      //   globalRouter.push({ name: 'login' });
      // }
    },
    async IN_AUTHORIZATION({ commit, dispatch }) {
      console.log('ssssssss')
      const url = `${API}logout`;
      const headers = {
        Authorization: localStorage.getItem('refresh_token'),
      };
      const refreshToken = localStorage.getItem('refresh_token');

      const res = await axios.post(url, '', {
        headers: {
          Authorization: refreshToken,
        },
      });

      return res.data.message;
    },
    async getData({ commit, dispatch }, _url) {
      const url = `${API}${_url}`;
      console.log(url)

      return
      const res = await axios.get(url);
      return res.data;
    },
    async TOKEN_CONNECT({ commit, dispatch }) {
      var BASE_URL = 'https://api.connect-sure.com'
      var API_KEY = 'nrK2GCAAazpRI2UCtI$SCfBd9XBg8EYS'
      var API_SECRET = 'S#FQ9zSHZysMm^5G@#n02X%Np1aNyF7G'
      var TOKEN_URL = '/check-policy?idCard='
      var UAT_TOKEN_URL = '/oauth/authorize'
      var PDF_URL = '/v2/pdf?idCard='
      const encodeBase64 = (key, secret) => {
        return btoa(`${key}:${secret}`);
      };
      const encodedCredentials = encodeBase64(API_KEY, API_SECRET)
      const response = await axios.post(
        `${BASE_URL}${UAT_TOKEN_URL}`,
        { method: 'authorize' },
        {
          headers: {
            Authorization: `Basic ${encodedCredentials}`,
          },
        },
      )
      console.log(response.data.token)
      return (response.data.token)
    },

    async getJwtDecode({ commit, dispatch }, value) {
      const data = jwtDecode(value);

      return data;
    },

    async data_addqueue({ commit, dispatch }, value) {
      console.log(value)
      commit('addChang', value);
      return value
    },
  },
  getters: {
    getChang: (state) => state.saveChang,
    getMapall: (state) => state.mapall,
  },
  strict: process.env.DEV,
})
